import React from "react"
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames"
import Container from 'react-bootstrap/Container';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { injectIntl } from "react-intl";

import Loader from "../Common/Loader/Loader";
import useQueryResponse from "../../lib/hooks/useQueryResponse";

import getPaymentMethodsQuery from "../../components/BookingDetail/PriceDetails/PaymentMethod/getAllPaymentMethods.graphql";


import messages from "../../locale/messages";
import { makePaymentAction } from "../../actions/payment/makePaymentAction";

import Toaster from "../Toaster/Toaster";
import showToaster from "../../helpers/toastrMessgaes/showToaster";

import bt from '../commonStyle.css';
import s from "./ProceedPaymentBanner.css"



const ProceedPaymentBanner = ({ id, paymentMethodId, stripe, elements, intl: { formatMessage }, paymentCurrency }) => {

    const loading = useSelector(state => state.loader.paymentLoading)
    const dispatch = useDispatch()
    const { data, loading: paymentMethodLoading } = useQueryResponse({
        query: getPaymentMethodsQuery,
        ssr: false,
        fetchPolicy: 'network-only'
    })

    const handleClick = () => {
        const selectedPaymentMethod = data?.getAllPaymentMethods?.results?.find(method => method.paymentType == paymentMethodId);
        if (selectedPaymentMethod && !selectedPaymentMethod?.isEnable) {
            showToaster({ messageId: 'noPaymentType', toasterType: 'error' });
            return;
        }
        else if (paymentMethodId == 5 && !paymentCurrency) {
            showToaster({ messageId: 'selectCurrency', toasterType: 'error' });
            return;
        }
        dispatch(makePaymentAction({ stripe, bookingId: id, paymentType: paymentMethodId, paymentCurrency: paymentCurrency }))
    }
    return (
        <div className={s.paymentBottomBannerContainer}>
            <Container>
                <div className={s.paymentBottomBannerWrapper}>
                    <Loader
                        type={"button"}
                        buttonType={'button'}
                        show={loading}
                        label={formatMessage(messages.proceedToPay)}
                        handleClick={() => handleClick()}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    >
                    </Loader>
                </div>
            </Container>
        </div>
    )
}

export default injectIntl(withStyles(bt, s)(ProceedPaymentBanner));

